import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, watch } from 'vue';
import { hasNoComma, isDepartmentName, required } from '@/lib/rule';
import { DepartmentTreeNode } from '@/interfaces/model/general/department';
import { useDepartmentComposable } from '@/composables/useDepartment';
import DepartmentParentPicker from '@/views/pages/companyDepartments/DepartmentParentPicker.vue';
import { buildCreatePreview } from '@/utils/departmentTree';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'DepartmentCreateDialog',
  props: {
    value: { type: Boolean },
    tree: null
  },
  emits: ["input", "created"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'created'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  tree: DepartmentTreeNode[];
};

const m = defineMessages({
  description: '部署名を入力してください。',
  parentDescription:
    '親部署を選択すると、選択した部署の配下に新しい部署が作成されます。',
  hierarchyPreview: '階層プレビュー',
});





const { isCreating, createCompanyDepartment } = useDepartmentComposable();

const isValidForm = ref(false);
const form = reactive<{ name: string; parentId: string | null }>({
  name: '',
  parentId: null,
});

// 開くたびに空の状態から始める
// v-dialog は一度開くと内容を DOM に残すため、閉じるときも入力をクリアする。
// 残したままだと閉じたダイアログ内の階層プレビューに部署名が残り、
// 一覧側と合わせて同じ文字列が 2 箇所に存在することになる。
watch(
  () => props.value,
  () => {
    form.name = '';
    form.parentId = null;
  }
);

const preview = computed(() =>
  buildCreatePreview(props.tree, form.parentId, form.name)
);

const canSubmit = computed(() => !!form.name && isValidForm.value);

const close = () => {
  if (isCreating.value) {
    return;
  }
  emit('input', false);
};

const submit = async () => {
  if (isCreating.value) {
    return;
  }
  const succeeded = await createCompanyDepartment({
    name: form.name,
    parent_id: form.parentId,
  });
  // 失敗時は入力を残したまま開いておく (再送できるように)
  if (!succeeded) {
    return;
  }
  close();
  emit('created');
};

return { __sfc: true,m, props, emit, isCreating, createCompanyDepartment, isValidForm, form, preview, canSubmit, close, submit, hasNoComma, isDepartmentName, required, DepartmentParentPicker, sharedMessages }
}

})